import { useEffect, useState } from 'react';
import { isMobile as isMobileDevice } from 'react-device-detect';

export const MOBILE_BREAKPOINT = 768;
export const TABLET_BREAKPOINT = 1024;

const useCheckMobileScreen = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowSizeChange = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  // Native apps (iOS/Android, including tablets) are detected by user-agent, so the
  // mobile treatment is preserved there regardless of viewport. On web/desktop it
  // reacts to the window width, so the layout adapts live while resizing the browser.
  const isMobile = isMobileDevice || width <= MOBILE_BREAKPOINT;
  const isTablet = !isMobileDevice && width > MOBILE_BREAKPOINT && width <= TABLET_BREAKPOINT;
  const isDesktop = !isMobileDevice && width > TABLET_BREAKPOINT;

  return { width, isMobile, isTablet, isDesktop };
};

export default useCheckMobileScreen;
